import type { StorageAdapter } from './types';

/**
 * In-memory StorageAdapter implementation.
 * Useful for headless testing, SSR fallback, and mock environments.
 */
export class MemoryStorageAdapter implements StorageAdapter {
  private store = new Map<string, string>();

  async getItem(key: string): Promise<string | null> {
    return this.store.get(key) ?? null;
  }

  async setItem(key: string, value: string): Promise<void> {
    this.store.set(key, value);
  }

  async removeItem(key: string): Promise<void> {
    this.store.delete(key);
  }

  async getAllKeys(): Promise<readonly string[]> {
    return Array.from(this.store.keys());
  }

  async multiRemove(keys: readonly string[]): Promise<void> {
    for (const key of keys) {
      this.store.delete(key);
    }
  }

  async clear(): Promise<void> {
    this.store.clear();
  }
}

export const memoryStorageAdapter = new MemoryStorageAdapter();
